import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { BasicComponent } from '@routes/tickets/ticket-edit/contents/basic/basic.component';
import { ScheduleComponent } from '@routes/tickets/ticket-edit/contents/schedule/schedule.component';
import { CustomerComponent } from '@routes/tickets/ticket-edit/contents/customer/customer.component';
import { ProductComponent } from '@routes/tickets/ticket-edit/contents/product/product.component';
import { PricingComponent } from '@routes/tickets/ticket-edit/contents/pricing/pricing.component';
import { SymptomsComponent } from '@routes/tickets/ticket-edit/contents/symptoms/symptoms.component';

@Component({
  selector: 'app-contents-template',
  template: '<ng-container #container></ng-container>'
})
export class ContentsTemplateComponent implements OnInit {
  @Input() data: any;

  componentRef: any;

  readonly templateMapper = {
    basic: BasicComponent,
    customer: CustomerComponent,
    product: ProductComponent,
    symptoms: SymptomsComponent,
    pricing: PricingComponent,
    schedule: ScheduleComponent,
  }

  @ViewChild('container', { read: ViewContainerRef }) private container: ViewContainerRef;

  constructor() {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.loadComponent();
    });
  }

  private loadComponent() {
    const component = this.data.component;
    const viewContainerRef = this.container;
    viewContainerRef.clear();
    const viewTemplateMapperElement = this.templateMapper[component];

    if (!component || !viewTemplateMapperElement) {
      return;
    }

    this.componentRef = viewContainerRef.createComponent(viewTemplateMapperElement);
  }

}
